import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { DownloadRelevancyCheckerQuery, RelevancyCheckerStatuses, TextVariableDto } from "app/ApiClient";

export type RelevancyCheckerVariable = {
  variableName?: string;
  token?: string;
  status?: RelevancyCheckerStatuses;
};

export type RelevancyCheckerInitiateTokens = {
  projectId?: number;
  variables?: RelevancyCheckerVariable[];
};

export type RelevancyCheckerDownloadToken = {
  projectId: number;
  token: string;
};

export type RelevancyCheckerVariableOrBatteryName = {
  projectId: number;
  name?: string;
};

export enum DownloadMode {
  Manual = "manual",
  Auto = "auto",
}

export type DownloadRelevancyThunkPayload = {
  request: DownloadRelevancyCheckerQuery;
  mode: DownloadMode;
};

export interface RelevancyCheckerState {
  errorMessage?: string;
  downloadRelevancyCheckerErrorMessage?: string;
  initiateRelevancyCheckerStatus: LoadingState;
  RelevancyCheckerVariables: TextVariableDto[];
  relevancyCheckerInitiateTokens?: RelevancyCheckerInitiateTokens[];
  relevancyDownloadingState: LoadingState;
  relevancyCheckerDownloadTokens: RelevancyCheckerDownloadToken[];
  resultMessageVariable:RelevancyCheckerVariableOrBatteryName[];
  errorMessageVariable:RelevancyCheckerVariableOrBatteryName[];
  partiallyFailedRelevancyCheckerBatteries: RelevancyCheckerVariableOrBatteryName[];
  presignedUrl: string | null;
  downloadMode: DownloadMode;
}

export const initialRelevancyChecker: RelevancyCheckerState = {
  RelevancyCheckerVariables: [],
  initiateRelevancyCheckerStatus: LoadingState.idle,
  relevancyCheckerInitiateTokens: [],
  relevancyDownloadingState: LoadingState.idle,
  relevancyCheckerDownloadTokens: [],
  resultMessageVariable: [],
  errorMessageVariable: [],
  partiallyFailedRelevancyCheckerBatteries: [],
  presignedUrl:null,
  downloadMode: DownloadMode.Manual,
};
